import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { decryptAEStoJSON } from "../../utils/utilities";
import { ROUTES } from "../../hooks/routes/routes-constant";
import PermissionGuard from "./permission-gurd";

const ProtectedRoutes = ({ component, moduleCode,requiredVerifiedStatus }) => {
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const loggedUser = useSelector((state) => state?.loggedUser?.value);
  const userData = decryptAEStoJSON(loggedUser);

  if (!accessToken || !userData) {
    return <Navigate to={ROUTES.INDEX} replace />;
  }

   if (requiredVerifiedStatus && userData?.isVerified !== requiredVerifiedStatus) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }
  return (
    <PermissionGuard moduleCode={moduleCode}>
      {component}
    </PermissionGuard>
  );
};

export default ProtectedRoutes;
